import React from 'react';
import { useSelector } from 'react-redux';
import { SCREEN_SIZE } from 'types';
import { selectScreenSize } from 'redux/session/selectors';
import UpgradePlan from '../UpgradePlan';
import { SwitcherDivider } from 'carbon-components-react';
import { ArrowLeft16 } from '@carbon/icons-react';

const TeamTeaserPanel: React.FC<Props> = ({ onOpenpanel }) => {
  const screenSize = useSelector(selectScreenSize);
  return (
    <>
      {screenSize && screenSize === SCREEN_SIZE.SM && (
        <div className="panel-back bx--switcher__item">
          <div className="panel-back-btn" onClick={() => onOpenpanel('menu')}>
            <ArrowLeft16 />
          </div>
        </div>
      )}
      <div className="panel-title bx--switcher__item">
        <div className="bx--switcher__item-link no-clickable">About teams</div>
      </div>
      <div className="teams-desc">
        Teams helps your users collaborate, providing shared workspaces for
        enquiries based on geographic extent. By adding enquiries to Teams it
        becomes easier for groups of users to search and manage responses.
        Private team is the default view.
      </div>
      <SwitcherDivider />
      <UpgradePlan />
    </>
  );
};

type Props = {
  onOpenpanel: Function;
};

export default React.memo(TeamTeaserPanel);
